import React from 'react';
import { useTheme } from '@material-ui/core/styles';

import { getIconColour } from '../../../../helpers/app';
import CrmSection from './CrmSection';
import DesktopIcon from '../../../../assets/icons/Desktop';
import { StyledGrid, AppInfo } from './common';
import { platformState } from './helper';
import { ApplicationInterface } from '../../../../interfaces/application';

type PropsType = {
  application: ApplicationInterface;
};

const CrmPlatforms: React.FC<PropsType> = ({ application }) => {
  const type = platformState(application);
  const theme = useTheme();

  return (
    <CrmSection
      icon={<DesktopIcon stroke={getIconColour(type, theme)} />}
      title="Platforms"
      description="Web, iOS, and/or Android app links and authentication."
      type={type}
    >
      <StyledGrid>
        <AppInfo label="Platforms" value={application.info.platforms.join(', ')} />
        <AppInfo
          label="OAuth Redirect URI(s)"
          value={application.setup.validRedirectUris.join(', ')}
        />
      </StyledGrid>
    </CrmSection>
  );
};

export default CrmPlatforms;
